/**
 * Who the UI offers what to, mirroring the server's `Authz`.
 *
 * <p>The server is the enforcement — every one of these routes is refused there too, and
 * hiding a screen has never stopped anyone typing its URL. This exists so the sidebar and
 * the routes agree with each other and with the API, from one list rather than from
 * twelve copies of a role array.
 *
 * <p>A Support Executive has a Super Admin's access. The content library is the whole of
 * the difference: they read it and never write it.
 */
export const ADMINISTRATION = ['SUPER_ADMIN', 'SUPPORT_EXECUTIVE'];

export const STAFF = [...ADMINISTRATION, 'SALES_REP'];

export const isAdministration = (role) => ADMINISTRATION.includes(role);

/** Adding or updating a title, chapter or file. Super Admin alone. */
export const canWriteContent = (role) => role === 'SUPER_ADMIN';
